export default __webpack_public_path__ + "static/media/portfolio.12648888.png";